import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { getApplicationStepReportById, getApplicationStepReportByIds } from '../../../../../utils/http';
import Reports from './AnnotationReportComponents/Reports';
import getUserRole from '../../../../../utils/localeStorage/getUserRole';
import onExportXLS from '../../../../../utils/createXLSDocument';


const customFinancialReportIds = ['2312-29/22-2С', '2412-41/22-1С', '2312-27/22-1С'];
function Step({
  applicationProp, step, isFinancialReport, isAnnotationReport, updateParentApplication,
}) {
  const [application, setApplication] = useState(null);
  const [prevStepApplications, setPrevStepApplications] = useState([]);

  useEffect(() => {
    const stepId = applicationProp.applicationStepReports.find((s) => Number(s.stepNumber) === step)?.id;
    const prevStepId = applicationProp.applicationStepReports.find((s) => Number(s.stepNumber) === step - 1)?.id;
    if (stepId && prevStepId) {
      Promise.all([getApplicationStepReportById(stepId),
        getApplicationStepReportByIds({ ids: applicationProp.applicationStepReports.filter((a) => Number(a.stepNumber) < step).map((a) => a.id).join(',') })])
        .then((resp) => {
          setApplication(resp[0]);
          setPrevStepApplications(resp[1]);
        });
    } else if (stepId) {
      getApplicationStepReportById(stepId)
        .then((resp) => {
          setApplication(resp);
          if (customFinancialReportIds.includes(resp.displayID)) {
            setPrevStepApplications([]);
          }
        });
    }
  }, []);

  const onDownloadXls = () => {
    onExportXLS(application, prevStepApplications);
  };

  return (
    <div style={{ overflowY: 'scroll', height: '79vh' }}>
      {application ? (
        <Reports
          // initialApplication={{ ...application, ...applicationProp, id: application.id }}
          initialApplication={{
            ...application, ...applicationProp, id: application.id, parentAppId: applicationProp.id,
          }}
          annotationReport={isAnnotationReport}
          financialReport={isFinancialReport}
          disabled={getUserRole() !== 'bigAdmin'}
          isShowAnnotationCard
          step={step}
          prevStepApplications={prevStepApplications}
          onDownloadXls={onDownloadXls}
          updateParentApplication={updateParentApplication}
        />
      ) : ''}
    </div>
  );
}

Step.propTypes = {
  applicationProp: PropTypes.shape().isRequired,
  step: PropTypes.number.isRequired,
  isAnnotationReport: PropTypes.bool.isRequired,
  isFinancialReport: PropTypes.bool.isRequired,
  updateParentApplication: PropTypes.func.isRequired,
};

export default withRouter(Step);
